export default {
  authenticated: false,
  user: null,
  me: null,
};
